import React from 'react';
import { Badge, Box, keyframes, Typography } from '@mui/material';

const glowAnimation = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(102, 126, 234, 0.5),
                0 0 10px rgba(102, 126, 234, 0.5),
                0 0 15px rgba(102, 126, 234, 0.5),
                0 4px 12px 0 rgba(0,0,0,0.2);
  }
  50% {
    box-shadow: 0 0 10px rgba(102, 126, 234, 0.8),
                0 0 20px rgba(102, 126, 234, 0.8),
                0 0 30px rgba(102, 126, 234, 0.8),
                0 4px 20px 0 rgba(102, 126, 234, 0.6);
  }
  100% {
    box-shadow: 0 0 5px rgba(102, 126, 234, 0.5),
                0 0 10px rgba(102, 126, 234, 0.5),
                0 0 15px rgba(102, 126, 234, 0.5),
                0 4px 12px 0 rgba(0,0,0,0.2);
  }
`;

interface FloatingButtonProps {
  onClick: () => void;
  isOpen: boolean;
  hasUnread?: boolean;
  unreadCount?: number;
  iconUrl: string;
}

const FloatingButton: React.FC<FloatingButtonProps> = ({
  onClick,
  isOpen,
  hasUnread = false,
  unreadCount = 0,
  iconUrl,
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 2147483646,
      }}
    >
      <Badge
        badgeContent={unreadCount}
        color="error"
        max={99}
        sx={{
          '& .MuiBadge-badge': {
            top: 8,
            right: 8,
            fontSize: '12px',
            fontWeight: 700,
            minWidth: '20px',
            height: '20px',
            padding: '0 4px',
          },
        }}
      >
        <Box
          onClick={onClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            padding: {xs: '2px', sm: '2px 20px 2px 2px'},
            borderRadius: '50px',
            // background: 'linear-gradient(to right, #667eea 0%, #5ce1e6 100%)',
            bgcolor: '#023d58',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': {
              // background: 'linear-gradient(to right, #5568d3 0%, #4bc5d4 100%)',
              bgcolor: '#023d58',
              transform: 'scale(1.05)',
            },
            animation: hasUnread ? `${glowAnimation} 2s ease-in-out infinite` : 'none',
            boxShadow: hasUnread
              ? '0 0 5px rgba(102, 126, 234, 0.5), 0 0 10px rgba(102, 126, 234, 0.5)'
              : '0 4px 20px rgba(102, 126, 234, 0.4)',
          }}
        >
          <Box
            component="img"
            src={iconUrl}
            alt="SAGE"
            sx={{
              width: 52,
              height: 52,
              borderRadius: '50%',
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              color: '#ffffff',
              fontWeight: 600,
              fontSize: '16px',
              whiteSpace: 'nowrap',
              userSelect: 'none',
              display: {xs: 'none', sm: 'block'}
            }}
          >
            Chat with SAGE
          </Typography>
        </Box>
      </Badge>
    </Box>
  );
};

export default FloatingButton;
